import React from "react";
import { Link } from "react-router-dom";
import "./AboutUs.scss";

const AboutUs = () => {
  return (
    <main>
      <div className="winery-header">
      </div>

      <article className="winery-container about-container">
        <img src="/images/sam.png" alt="sam"></img>
        <div className="winery-content about-content">
        <p>
            Welcome to "It's My Wine", your number one tool to create
            personalized gifts. We are dedicated to giving you the very best way
            to share your celebration, sentiments and special occasions through
            a custom designed label on the bottle of your favourite wine.
            Founded in GTA by a lovely couple, "It's My Wine" has come a long
            way from just an idea and vision in mind. "It's My Wine" started
            with passion for giving and celebrating life for any reason every
            day.
          </p>
          <br/>
          <p>
            We now offer to serve customers throughout GTA and thrilled to be a
            part of your expirience. Whether you decide to custom design a wine
            label for your Bridesmaids & Groomsman, Proposal, Birthdays, Family
            and more. We hope you enjoy our products as much as we enjoy
            offering them to you. If you have any question or comments, please
            do not hesitate to{" "}
            <Link className="link" to="/contact">
              contact us.
            </Link>
          </p>
          <br />
          <p>Sincerely,</p>
          <p>Sam & Kira</p>
          <p>Creators of "It's My Wine"</p>
          <br />
        </div>
      </article>
      {/* <section className="about">
        <img src="/images/about-us.jpg" alt="" />
        <article>
          <h1 className="page-title">About Us</h1>

          <p>
            Welcome to "It's My Wine", your number one tool to create
            personalized gifts. We are dedicated to giving you the very best way
            to share your celebration, sentiments and special occasions through
            a custom designed label on the bottle of your favourite wine.
            Founded in GTA by a lovely couple, "It's My Wine" has come a long
            way from just an idea and vision in mind. "It's My Wine" started
            with passion for giving and celebrating life for any reason every
            day.
          </p>
          <br/>
          <p>
            We now offer to serve customers throughout GTA and thrilled to be a
            part of your expirience. Whether you decide to custom design a wine
            label for your Bridesmaids & Groomsman, Proposal, Birthdays, Family
            and more. We hope you enjoy our products as much as we enjoy
            offering them to you. If you have any question or comments, please
            do not hesitate to{" "}
            <Link className="link" to="/contact">
              contact us.
            </Link>
          </p>
          <br />
          <p>Sincerely,</p>
          <p>Sam & Kira</p>
          <p>Creators of "It's My Wine"</p>
          <br />
        </article>
      </section> */}
    </main>
  );
};

export default AboutUs;
